import {widgetLibraries as Widgets} from "./useWidgetsLibrary.js";
import { useWidgetNames } from "./useWidgetNames.js";

export function useWidgetBuilder(name = '') {
    const { widgetNames } = useWidgetNames();
    
    switch (name) {
        case widgetNames.CRM_AVERAGE_DURATION:
          return  Widgets.CrmAverageDuration ;
      
        case widgetNames.CRM_AVERAGE_DURATION_BY_OUTCOME:
          return  Widgets.CrmAverageDurationByOutcome ; 
      
        case widgetNames.CRM_ESTIMATE_SALES_BY_PERIOD:
          return  Widgets.CrmEstimateSalesByPeriod ;    
      
        case widgetNames.CRM_ESTIMATE_STATUS_TURNOVER:  
          return  Widgets.CrmEstimateStatusTurnover ;
      
        case widgetNames.CRM_ESTIMATE_STATUS_TURNOVER_PERCENTAGE:
          return  Widgets.CrmEstimateStatusTurnoverPercentage ;   
       
        case widgetNames.CRM_GET_AVERAGE_PAYMENT_DELAY:
          return  Widgets.CrmGetAveragePaymentDelay ;   
      
        case widgetNames.CRM_GET_INVOICE_AND_ADVANCE_COUNT_STATISTIC:   
          return  Widgets.CrmGetInvoiceAndAdvanceCountStatistic ;
      
        case widgetNames.CRM_GET_OPPORTUNITIES_CONVERSION_RATE:
          return  Widgets.CrmGetOpportunitiesConversionRate ;
      
        case widgetNames.CRM_GET_TOP_ACTIVITIES_FOR_WON_OPPORTUNITIES:
          return  Widgets.CrmGetTopActivitiesForWonOpportunities ; 
      
        case widgetNames.CRM_GET_TOTAL_APPOINTMENT_BY_STATUS:   
          return  Widgets.CrmGetTotalAppointmentByStatus ;
      
        case widgetNames.CRM_INVOICE_STAT_BY_STATUS:     
          return  Widgets.CrmInvoiceStatByStatus ;
      
        case widgetNames.CRM_INVOICE_TURN_OVER:    
          return  Widgets.CrmInvoiceTurnOver ;
      
        case widgetNames.CRM_OPPORTUNITIES_BY_STAGE:
          return  Widgets.CrmOpportunitiesByStage ;
      
        case widgetNames.CRM_OPPORTUNITIES_TOTAL_BY_STATUS:    
          return  Widgets.CrmOpportunitiesTotalByStatus ;    
      
        case widgetNames.CRM_SALES_BY_PERIODS:    
          return  Widgets.CrmSalesByPeriods ;
      
        case widgetNames.CRM_TOP_CONTACTS:  
          return  Widgets.CrmTopContacts ;
      
        case widgetNames.CRM_TOP_CUSTOMER:   
          return  Widgets.CrmTopCustomer ;
      
        case widgetNames.CRM_TOP_OPPORTUNITIES_ESTIMATE_STAT:
          return  Widgets.CrmTopOpportunitiesEstimateStat ;    
      
        case widgetNames.CRM_TOP_OPPORTUNITIES_LOST_REASON:
          return  Widgets.CrmTopOpportunitiesLostReason ;
      
        case widgetNames.CRM_TOP_PRODUCT:      
          return  Widgets.CrmTopProduct ;
       
        case widgetNames.CRM_TOP_PROSPECTS:
          return  Widgets.CrmTopProspects ;
      
        case widgetNames.CRM_TOP_TOTAL_APPOINTMENT_PER_CREATOR:   
          return  Widgets.CrmTopTotalAppointmentPerCreator ;
      
        case widgetNames.PROJECT_USER_PERFORMANCE:     
          return  Widgets.ProjectUserPerformance ;
      
        default:
          return  Widgets.WidgetCard ;
      }
      

}